(() => {
  const ROOT_SELECTOR = '[data-ns-htbn]';
  const SCROLLER_SELECTOR =
    '.ns-htbn__nav-list, .ns-htbn__tab-list';

  /**
   * Scroll the selected navigation item or tab
   * into the visible center of its horizontal container.
   */
  const scrollItemHorizontally = (item, behavior = 'smooth') => {
  const scroller = item?.closest(SCROLLER_SELECTOR);

  if (!scroller) {
    return;
  }

  const scrollerRect =
    scroller.getBoundingClientRect();

  const itemRect =
    item.getBoundingClientRect();

  const delta =
    itemRect.left +
    itemRect.width / 2 -
    (
      scrollerRect.left +
      scrollerRect.width / 2
    );

  if (Math.abs(delta) > 2) {
    scroller.scrollBy({
      left: delta,
      behavior
    });
  }
};

  /**
   * Add horizontal scrolling controls to one
   * navigation list or architecture tab list.
   */
  const initHorizontalScroller = (scroller) => {
    if (
      !scroller ||
      scroller.dataset.nsHtbnScrollerReady ===
        'true'
    ) {
      return;
    }

    scroller.dataset.nsHtbnScrollerReady = 'true';

    /*
     * Create the outer shell used by the
     * left and right scroll buttons.
     */
    const shell = document.createElement('div');

    shell.className = 'ns-htbn__scroll-shell';

    const previousButton =
      document.createElement('button');

    previousButton.type = 'button';

    previousButton.className =
      'ns-htbn__scroll-button ' +
      'ns-htbn__scroll-button--previous';

    previousButton.setAttribute(
      'aria-label',
      'Scroll tabs left'
    );

    previousButton.innerHTML =
      '<span aria-hidden="true">‹</span>';

    const nextButton =
      document.createElement('button');

    nextButton.type = 'button';

    nextButton.className =
      'ns-htbn__scroll-button ' +
      'ns-htbn__scroll-button--next';

    nextButton.setAttribute(
      'aria-label',
      'Scroll tabs right'
    );

    nextButton.innerHTML =
      '<span aria-hidden="true">›</span>';

    const parent = scroller.parentNode;

    if (!parent) {
      return;
    }

    /*
     * Move the existing navigation list into
     * the new scroll shell.
     */
    parent.insertBefore(shell, scroller);

    shell.appendChild(scroller);
    shell.appendChild(previousButton);
    shell.appendChild(nextButton);

    /*
     * Make the horizontal container keyboard focusable.
     */
    if (!scroller.hasAttribute('tabindex')) {
      scroller.tabIndex = 0;
    }

    /**
     * Enable or disable the left and right buttons
     * depending on the current scroll position.
     */
    const updateControls = () => {
      const maxScrollLeft = Math.max(
        0,
        scroller.scrollWidth -
          scroller.clientWidth
      );

      const canScroll = maxScrollLeft > 2;
      const atStart = scroller.scrollLeft <= 2;

      const atEnd =
        scroller.scrollLeft >=
        maxScrollLeft - 2;

      shell.classList.toggle(
        'is-scrollable',
        canScroll
      );

      shell.classList.toggle(
        'can-scroll-left',
        canScroll && !atStart
      );

      shell.classList.toggle(
        'can-scroll-right',
        canScroll && !atEnd
      );

      previousButton.disabled =
        !canScroll || atStart;

      nextButton.disabled =
        !canScroll || atEnd;
    };

    /**
     * Scroll approximately one visible page
     * to the left or right.
     */
    const scrollByPage = (direction) => {
      const distance = Math.max(
        180,
        Math.round(
          scroller.clientWidth * 0.72
        )
      );

      scroller.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    };

    previousButton.addEventListener(
      'click',
      () => {
        scrollByPage(-1);
      }
    );

    nextButton.addEventListener(
      'click',
      () => {
        scrollByPage(1);
      }
    );

    scroller.addEventListener(
      'scroll',
      updateControls,
      {
        passive: true
      }
    );

    /*
     * Keyboard controls for the horizontal
     * scroll container itself.
     */
    scroller.addEventListener(
      'keydown',
      (event) => {
        if (event.target !== scroller) {
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollByPage(1);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollByPage(-1);
        }

        if (event.key === 'Home') {
          event.preventDefault();

          scroller.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }

        if (event.key === 'End') {
          event.preventDefault();

          scroller.scrollTo({
            left: scroller.scrollWidth,
            behavior: 'smooth'
          });
        }
      }
    );

    /*
     * Mouse drag support.
     *
     * This is particularly useful inside the
     * Shopify Theme Editor mobile preview,
     * where a desktop mouse is used inside an iframe.
     */
    let pointerId = null;
    let pointerStartX = 0;
    let scrollStartLeft = 0;
    let hasDragged = false;
    let suppressNextClick = false;

    scroller.addEventListener(
  'pointerdown',
  (event) => {
    if (event.pointerType === 'touch') {
      return;
    }

    if (event.button !== 0) {
      return;
    }

    pointerId = event.pointerId;
    pointerStartX = event.clientX;
    scrollStartLeft =
      scroller.scrollLeft;

    hasDragged = false;
  }
);

scroller.addEventListener(
  'pointermove',
  (event) => {
    if (
      pointerId === null ||
      event.pointerId !== pointerId
    ) {
      return;
    }

    const distance =
      event.clientX -
      pointerStartX;

    /*
     * 只有鼠标真正移动超过10px后，
     * 才把这次操作认定为拖动。
     *
     * 普通点击不会再被滚动容器拦截。
     */
    if (
      !hasDragged &&
      Math.abs(distance) > 10
    ) {
      hasDragged = true;

      scroller.classList.add(
        'is-dragging'
      );

      try {
        if (
          typeof scroller.setPointerCapture ===
          'function'
        ) {
          scroller.setPointerCapture(
            pointerId
          );
        }
      } catch (_error) {
        /*
         * Shopify编辑器iframe可能拒绝
         * Pointer Capture，忽略即可。
         */
      }
    }

    if (!hasDragged) {
      return;
    }

    event.preventDefault();

    scroller.scrollLeft =
      scrollStartLeft - distance;
  }
);
    /**
     * Finish mouse or pen dragging.
     */
    const endPointerDrag = (event) => {
      if (pointerId === null) {
        return;
      }

      if (
        event.pointerId !== undefined &&
        event.pointerId !== pointerId
      ) {
        return;
      }

      /*
       * Prevent the click event that can fire
       * immediately after a drag.
       */
      if (hasDragged) {
        suppressNextClick = true;

        window.setTimeout(() => {
          suppressNextClick = false;
        }, 0);
      }

      if (
        typeof scroller.releasePointerCapture ===
        'function'
      ) {
        try {
          scroller.releasePointerCapture(
            pointerId
          );
        } catch (_error) {
          // Ignore release errors in preview iframes.
        }
      }

      pointerId = null;
      hasDragged = false;

      scroller.classList.remove(
        'is-dragging'
      );

      updateControls();
    };

    scroller.addEventListener(
      'pointerup',
      endPointerDrag
    );

    scroller.addEventListener(
      'pointercancel',
      endPointerDrag
    );

    scroller.addEventListener(
      'lostpointercapture',
      endPointerDrag
    );

    scroller.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    /*
     * Recalculate the arrow states when the
     * viewport or content width changes.
     */
    if ('ResizeObserver' in window) {
      const resizeObserver =
        new ResizeObserver(
          updateControls
        );

      resizeObserver.observe(scroller);

      scroller._nsHtbnResizeObserver =
        resizeObserver;
    } else {
      window.addEventListener(
        'resize',
        updateControls,
        {
          passive: true
        }
      );
    }

    window.requestAnimationFrame(
      updateControls
    );
  };

  /**
   * Initialize both horizontal navigation groups:
   *
   * 1. Overview / Business Scenarios / Reference Designs...
   * 2. Small Venue / Medium Venue / Multi-Floor Venue
   */
  const initHorizontalScrollers = (root) => {
    root
      .querySelectorAll(
        SCROLLER_SELECTOR
      )
      .forEach(
        initHorizontalScroller
      );
  };

  /**
   * Initialize the architecture tab panels.
   */
  const initTabs = (root) => {
    const tabGroups =
      root.querySelectorAll(
        '[data-ns-htbn-tabs]'
      );

    tabGroups.forEach((group) => {
      if (
        group.dataset.nsHtbnTabsReady ===
        'true'
      ) {
        return;
      }

      group.dataset.nsHtbnTabsReady =
        'true';

      const tabs = Array.from(
        group.querySelectorAll(
          '[role="tab"]'
        )
      );

      const panels = Array.from(
        group.querySelectorAll(
          '[role="tabpanel"]'
        )
      );

      if (
        !tabs.length ||
        !panels.length
      ) {
        return;
      }

      /**
       * Activate one architecture tab
       * and hide the other panels.
       */
      const activate = (
        selectedTab,
        moveFocus = false
      ) => {
        const panelId =
          selectedTab.getAttribute(
            'aria-controls'
          );

        tabs.forEach((tab) => {
          const isActive =
            tab === selectedTab;

          tab.setAttribute(
            'aria-selected',
            String(isActive)
          );

          tab.tabIndex =
            isActive ? 0 : -1;

          tab.classList.toggle(
            'is-active',
            isActive
          );
        });

        panels.forEach((panel) => {
          const isActive =
            panel.id === panelId;

          panel.hidden = !isActive;

          panel.tabIndex =
            isActive ? 0 : -1;

          panel.classList.toggle(
            'is-active',
            isActive
          );
        });

        /*
         * Keep the selected tab visible
         * inside the horizontal scroller.
         */
        scrollItemHorizontally(
          selectedTab
        );

        if (moveFocus) {
          try {
            selectedTab.focus({
              preventScroll: true
            });
          } catch (_error) {
            selectedTab.focus();
          }
        }
      };

      tabs.forEach(
        (tab, index) => {
          tab.addEventListener(
            'click',
            () => {
              activate(tab);
            }
          );

          tab.addEventListener(
            'keydown',
            (event) => {
              let targetIndex = null;

              if (
                event.key ===
                'ArrowRight'
              ) {
                targetIndex =
                  (index + 1) %
                  tabs.length;
              }

              if (
                event.key ===
                'ArrowLeft'
              ) {
                targetIndex =
                  (
                    index -
                    1 +
                    tabs.length
                  ) %
                  tabs.length;
              }

              if (
                event.key === 'Home'
              ) {
                targetIndex = 0;
              }

              if (
                event.key === 'End'
              ) {
                targetIndex =
                  tabs.length - 1;
              }

              if (
                targetIndex === null
              ) {
                return;
              }

              event.preventDefault();

              activate(
                tabs[targetIndex],
                true
              );
            }
          );
        }
      );

      const presetTab =
        tabs.find(
          (tab) =>
            tab.getAttribute(
              'aria-selected'
            ) === 'true'
        ) || tabs[0];

      activate(presetTab);
    });
  };

  /**
   * Initialize the sticky page anchor navigation.
   */
  const initNavigation = (root) => {
    const links = Array.from(
      root.querySelectorAll(
        '[data-ns-htbn-nav-link]'
      )
    );

    if (!links.length) {
      return;
    }

    links.forEach((link) => {
      link.addEventListener(
        'click',
        (event) => {
          const targetId =
            link.getAttribute('href');

          if (
            !targetId ||
            !targetId.startsWith('#')
          ) {
            return;
          }

          const target =
            root.querySelector(
              targetId
            );

          if (!target) {
            return;
          }

          event.preventDefault();

          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          try {
            window.history.replaceState(
              null,
              '',
              targetId
            );
          } catch (_error) {
            /*
             * Shopify preview URLs can
             * reject history updates.
             */
          }
        }
      );
    });

    /*
     * Keep the active navigation item highlighted
     * while the visitor scrolls through the page.
     */
    if (
      !(
        'IntersectionObserver' in
        window
      )
    ) {
      return;
    }

    const linkMap = new Map();

    links.forEach((link) => {
      const targetId =
        link.getAttribute('href');

      const section = targetId
        ? root.querySelector(
            targetId
          )
        : null;

      if (section) {
        linkMap.set(
          section,
          link
        );
      }
    });

    if (!linkMap.size) {
      return;
    }

    const observer =
      new IntersectionObserver(
        (entries) => {
          const visibleEntry =
            entries
              .filter(
                (entry) =>
                  entry.isIntersecting
              )
              .sort(
                (entryA, entryB) =>
                  entryB.intersectionRatio -
                  entryA.intersectionRatio
              )[0];

          if (!visibleEntry) {
            return;
          }

          links.forEach((link) => {
            link.classList.remove(
              'is-active'
            );
          });

          const activeLink =
            linkMap.get(
              visibleEntry.target
            );

          if (activeLink) {
            activeLink.classList.add(
              'is-active'
            );

            scrollItemHorizontally(
              activeLink
            );
          }
        },
        {
          rootMargin:
            '-25% 0px -65% 0px',

          threshold: [
            0.01,
            0.15,
            0.4
          ]
        }
      );

    linkMap.forEach(
      (_link, section) => {
        observer.observe(section);
      }
    );

    root._nsHtbnObserver =
      observer;
  };

  /**
   * Initialize FAQ accordion behavior.
   *
   * The FAQ content itself remains in the
   * original HTML and does not depend on JavaScript.
   */
  const initDetails = (root) => {
    const details = Array.from(
      root.querySelectorAll(
        '.ns-htbn__faq'
      )
    );

    details.forEach((item) => {
      if (
        item.dataset.nsHtbnFaqReady ===
        'true'
      ) {
        return;
      }

      item.dataset.nsHtbnFaqReady =
        'true';

      item.addEventListener(
        'toggle',
        () => {
          if (!item.open) {
            return;
          }

          details.forEach(
            (otherItem) => {
              if (
                otherItem !== item &&
                otherItem.hasAttribute(
                  'data-close-others'
                )
              ) {
                otherItem.open =
                  false;
              }
            }
          );
        }
      );
    });
  };

  /**
   * Initialize one High-Traffic Network section.
   */
  const initRoot = (root) => {
    if (
      !root ||
      root.dataset.nsHtbnReady ===
        'true'
    ) {
      return;
    }

    root.dataset.nsHtbnReady =
      'true';

    initHorizontalScrollers(root);
    initTabs(root);
    initNavigation(root);
    initDetails(root);
  };

  /**
   * Initialize every matching section
   * inside the supplied document or scope.
   */
  const initAll = (
    scope = document
  ) => {
    if (
      typeof scope.matches ===
        'function' &&
      scope.matches(ROOT_SELECTOR)
    ) {
      initRoot(scope);
    }

    if (
      typeof scope.querySelectorAll ===
      'function'
    ) {
      scope
        .querySelectorAll(
          ROOT_SELECTOR
        )
        .forEach(initRoot);
    }
  };

  /**
   * Disconnect observers when Shopify
   * removes or reloads the section.
   */
  const destroyRoot = (root) => {
    if (!root) {
      return;
    }

    if (root._nsHtbnObserver) {
      root._nsHtbnObserver.disconnect();
    }

    root
      .querySelectorAll(
        SCROLLER_SELECTOR
      )
      .forEach((scroller) => {
        if (
          scroller
            ._nsHtbnResizeObserver
        ) {
          scroller
            ._nsHtbnResizeObserver
            .disconnect();
        }
      });
  };

  /*
   * Initial page load.
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      }
    );
  } else {
    initAll();
  }

  /*
   * Shopify Theme Editor:
   * reinitialize after a section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  /*
   * Shopify Theme Editor:
   * clean up observers before removal.
   */
  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const root =
        typeof event.target.matches ===
          'function' &&
        event.target.matches(
          ROOT_SELECTOR
        )
          ? event.target
          : event.target.querySelector(
              ROOT_SELECTOR
            );

      destroyRoot(root);
    }
  );
})();